import "@story/story_assets/dom_extend";

function addAttachment(container, file) {
	const baseName = container.getAttribute("data-attachments");

	let id = container.children.length;
	for (const el of document.querySelectorAll(`[name^="${baseName}"]`)) {
		const name = el.getAttribute("name");
		const match = name.match(/\]\[(\d+)\]/);
		if (match && match[1]) {
			const currentId = parseInt(match[1]);
			if (id <= currentId) {
				id = currentId + 1;
			}
		}
	}

	const input = document.createElement("input");
	input.type = "file";
	input.name = `${baseName}[${id}][attachment]`;

	const dataTransfer = new DataTransfer();
	dataTransfer.items.add(file);
	input.files = dataTransfer.files;
	input.classList.add("d-none");

	const template = document.createElement("div");
	template.classList.add("col-auto");
	template.setAttribute("data-attachment", baseName);

	template.innerHTML = `
<div class="form-img-attachment">
	<div class="form-img-attachment-img">
		<img src="${URL.createObjectURL(file)}" class="img-cover" alt="${file.name}">
	</div>
	<div class="form-img-attachment-title mb-2">
		${file.name}
	</div>
	<div class="text-center">
		<a href="#" class="btn btn-xs btn-secondary w-100" data-remove-attachment="${baseName}">Smazat</a>
	</div>
</div>
	`;
	template.appendChild(input);

	container.insertBefore(template, container.lastElementChild);
}

document.addEventSelectorListener("change", "[data-append-attachment]", function(event, target) {
	event.preventDefault();
	const baseName = target.getAttribute("data-append-attachment");
	const container = target.closest("form").querySelector(`[data-attachments='${baseName}']`);

	for (const file of target.files) {
		addAttachment(container, file);
	}

	target.value = "";
});

document.addEventSelectorListener("change", "[data-destroy-attachment]", function(event, target) {
	if (!target.checked) {
		return;
	}

	const baseName = target.getAttribute("data-destroy-attachment");
	const attachment = target.closest(`[data-attachment='${baseName}']`);
	if (attachment) {
		attachment.classList.add("d-none");
	}
});

document.addEventSelectorListener("click", "[data-remove-attachment]", function(event, target) {
	event.preventDefault();
	const baseName = target.getAttribute("data-remove-attachment");
	const attachment = target.closest(`[data-attachment='${baseName}']`);
	if (attachment) {
		attachment.remove();
	}
});
